export const LINE_HEIGHT = 20;
export const GAP_BOTTOM = 30;
export const CHAT_GAP = 16;
export const HEADER_BASE_HEIGHT = 118;
export const HEADER_TOP_PADDING = 24;
export const HEADER_BOTTOM_SPACING = 16;
export const HEADER_DEFAULT_TOTAL_HEIGHT = HEADER_BASE_HEIGHT + HEADER_TOP_PADDING + HEADER_BOTTOM_SPACING + CHAT_GAP * 2;
export const MIN_INPUT_HEIGHT = 60;
export const MIN_INPUT_ROWS = 2;
export const DEFAULT_INPUT_HEIGHT = 240;
export const DEFAULT_INPUT_ROWS = 4;
